<template>
  <div class="specific-people-info-container">
    <h2 class="people-headings">{{ componentHeading }}</h2>

    <p v-if="!testator.maritalStatus" class="person-info">
      You have not selected your marital status
    </p>

    <div class="person-info">
      <p>{{ $options.maritalStatuses[testator.maritalStatus] }}</p>
    </div>

    <div v-if="testator.isMarried" class="person-info">
      <p v-if="!spouse.id">Please add your spouse/partner</p>
      <p>{{ spouse.fullName }}</p>
      <p>{{ $options.maritalRegimes[testator.maritalRegime] }}</p>
    </div>
    <div class="card-button-container">
      <FunkButton button-text="Edit" @buttonClicked="edit" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SpouseOverview',
    props: {
      testator: {
        type: Object,
        required: true,
      },
      spouse: {
        type: Object,
        required: true,
      },
    },
    maritalRegimes: {
      OUT_OF_COMMUNITY_NO_ACCRUAL:
        'Out of community of property without accrual',
      OUT_OF_COMMUNITY_ACCRUAL: 'Out of community of property with accrual',
      IN_COMMUNITY: 'In community of property',
      MUSLIM_RITES: 'According to Muslim rites',
      CUSTOMARY: 'According to Customary Laws',
    },
    maritalStatuses: {
      MARRIED: 'Married',
      SINGLE: 'Single',
      LIVING_BUT_NOT_MARRIED: 'Living with a partner but not married',
      CIVIL_PARTNERSHIP: 'Civil Partnership',
      ENGAGED: 'Engaged',
      WIDOWED: 'Widowed',
      WIDOWED_AND_REMARRIED: 'Widowed and remarried',
      MARRIED_BUT_SEPARATED: 'Married but separated',
      CIVIL_PARTNERSHIP_BUT_SEPARATED: 'Civil partnership but separated',
      DIVORCED: 'Divorced',
      NOT_MARRIED: 'Not married',
    },
    computed: {
      componentHeading() {
        if (!this.testator.maritalRegime) return 'Spouse or life partner';
        return this.testator.maritalRegime !== 'LIFE_PARTNER'
          ? 'Spouse'
          : 'Life partner';
      },
      isGBWill() {
        return this.testator.willCountry == 'GB';
      },
    },
    methods: {
      edit() {
        this.$router.push({
          name: 'Married',
          query: { peopleWizard: 'spouse' },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../constants/styles/people-overview-info-blocks.scss';
</style>
